import CertificateBanner from "./CertificateBanner";
import Certificate from "../Components/Certificate/Certificate";
import { Helmet } from "react-helmet";

const CertificateSummary = () => {
  return (
    <>
      <Helmet>
        {/* Meta tags */}
        <title>
          Diamond Certificates and Reports | Sreehari Diamond Report{" "}
        </title>
        <meta
          name="description"
          content="Learn about diamond certificates and how to verify a diamond's quality, authenticity, and value. Trusted labs, grading reports, and what to look for."
        />
        <meta
          name="keywords"
          content="lab grown diamond certification, best diamond certification in india, Gemstone Identification Lab, Diamond, Gemological Laboratory, Diamond Testing Lab, Diamond Sealing service, Diamond Hologram Stickers, Hologram Stickers for Certificates, Best diamond online services, 4 cs' of diamonds, 4cs education of diamond"
        />
        {/* OG tags */}
        <meta
          property="og:title"
          content="Diamond Certificates and Reports | Sreehari Diamond Report"
        />
        <meta
          property="og:description"
          content="Learn about diamond certificates and how to verify a diamond's quality, authenticity, and value. Trusted labs, grading reports, and what to look for."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://sreeharidiamondlab.com/certificates"
        />
        <meta
          property="og:image"
          content="https://sreeharidiamondlab.com/static/media/logo.04f6bad90dcf8391f785.png
"
        />
        <meta property="og:site_name" content="sreehari diamond laboratory" />
        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="Diamond Certificates and Reports | Sreehari Diamond Report"
        />
        <meta
          name="twitter:description"
          content="Learn about diamond certificates and how to verify a diamond's quality, authenticity, and value. Trusted labs, grading reports, and what to look for."
        />
        <meta
          name="twitter:image"
          content="https://sreeharidiamondlab.com/static/media/logo.04f6bad90dcf8391f785.png
"
        />
        <meta name="twitter:site" content="sreehari diamond laboratory" />
        <link
          rel="canonical"
          href="https://sreeharidiamondlab.com/certificates"
        />{" "}
      </Helmet>
      <CertificateBanner />

      <Certificate />
    </>
  );
};

export default CertificateSummary;
